<template>
  <header class="header">
    <div class="container-cls">
      <div class="header-inner">
        <div class="logo">
          <router-link :to="{ path: '/' }">
            <img
              src="https://growbiotech-prod.s3.amazonaws.com/1606973000233.png"
              alt
            />
          </router-link>
        </div>
        <div class="header-right ml-auto">
          <div class="header-right-inner">
            <div class="nav-main">
              <nav class="nav">
                <ul>
                  <li>
                    <router-link class="header-name" :to="{ path: '/' }"
                      >Home</router-link
                    >
                  </li>
                  <li>
                    <v-menu offset-y open-on-hover>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn text v-bind="attrs" v-on="on">Explore </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, index) in items"
                          :key="index"
                          :to="{ path: item.path }"
                        >
                          <v-list-item-title class="explore-menus">{{
                            item.title
                          }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </li>
                  <li>
                    <router-link class="btn" :to="{ path: 'signup' }"
                      >SIGN UP</router-link
                    >
                  </li>
                  <li>
                    <router-link class="header-name" :to="{ path: 'login' }"
                      >LOG IN</router-link
                    >
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "HomeHeader",
  data() {
    return {
      items: [
        { title: "News & Articles", path: "/news-feed" },
        { title: "Find Doctor", path: "/find-doctor" }
      ]
    };
  }
};
</script>
<style scoped>
.v-menu__content {
  z-index: 99 !important;
}
</style>
